import React from 'react'
import { WorkArea } from '../../../../types/Project/WorkArea'
import { 
	Box, 
	List, 
	ListItemButton, 
	ListItemIcon, 
	ListItemText, 
	Typography,
	Divider,
	Paper
} from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import { useTheme } from '@mui/material/styles'

type WorkAreaListProps = {
	workAreas: WorkArea[]
	selected?: WorkArea
	setSelected: (wa: WorkArea) => void
}

export function WorkAreaList({ workAreas, selected, setSelected }: WorkAreaListProps) {
	const theme = useTheme()

	return (
		<Box sx={{ 
			display: 'flex', 
			flexDirection: 'column',
			height: '100%',
			overflow: 'hidden'
		}}>
			<Paper 
				elevation={0}
				sx={{ 
					p: 2,
					borderRadius: 0,
					borderBottom: '1px solid',
					borderColor: 'divider',
					backgroundColor: 'background.paper'
				}}
			>
				<Typography 
					variant="subtitle1" 
					sx={{ 
						fontWeight: 600,
						color: 'text.primary'
					}}
				>
					Work Areas
				</Typography>
			</Paper>
			<List 
				sx={{
					flex: 1,
					overflow: 'auto',
					'& .MuiListItemButton-root': {
						borderRadius: '4px',
						mx: 1,
						my: 0.5,
						'&.Mui-selected': {
							backgroundColor: theme.palette.grey[100],
							'&:hover': {
								backgroundColor: theme.palette.grey[200],
							},
							'& .MuiListItemIcon-root': {
								color: theme.palette.text.primary,
							},
							'& .MuiListItemText-primary': {
								color: theme.palette.text.primary,
								fontWeight: 600,
							}
						},
						'&:hover': {
							backgroundColor: theme.palette.action.hover,
						}
					}
				}}
			>
				{[...workAreas]
					.sort((a, b) => a.name.localeCompare(b.name))
					.map((wa) => (
					<ListItemButton
						key={wa.id}
						selected={selected && selected.id === wa.id}
						onClick={() => setSelected(wa)}
					>
						<ListItemIcon sx={{ minWidth: '40px' }}>
							<CircleIcon 
								sx={{ 
									fontSize: '12px',
									color: selected && selected.id === wa.id 
										? theme.palette.text.primary
										: wa.color || theme.palette.text.secondary
								}} 
							/>
						</ListItemIcon>
						<ListItemText 
							primary={wa.name}
							sx={{
								'& .MuiListItemText-primary': {
									fontSize: '0.875rem',
									transition: 'color 0.2s ease-in-out'
								}
							}}
						/>
					</ListItemButton>
				))}
			</List>
		</Box>
	)
}
